<template>
  <div class="referral-form-container">
    <Panel
      title="4.ข้อมูลบุคคลอ้างอิง (Referral)"
      optionText="มีข้อมูลบุคคลอ้างอิง"
      isShowOptionCheckbox
      :isCheckOption="isHasReferrer"
      :onCheckOptionCallback="onCheckHasReferralPerson"
      :isCollapse="!isHasReferrer"
      :isOptionDisabled="disabledForm"
    >
      <div class="referral-form-body">
        <div class="form-group">
          <div class="input-group">
            <div class="referral-radio-container">
              <Radio
                name="referrerType"
                label="new"
                v-model="referrerType"
                :disabled="disabledForm"
              >
                กรอกข้อมูลใหม่
              </Radio>
            </div>
            <div class="referral-radio-container">
              <Radio
                name="referrerType"
                label="existing"
                v-model="referrerType"
                :disabled="disabledForm"
              >
                ค้นหาข้อมูลพนักงาน
              </Radio>
            </div>
          </div>
        </div>
        <div v-show-slide="isReferrerExisting" class="referral-search-container row">
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                รหัสพนักงาน
              </span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="staffSearchId"
                :disabled="disabledForm"
              />
            </div>
          </div>
          <Button
            class="btn-dark btn-s-xs"
            type="info"
            @click.native="onSearchStaffInformation"
            :disabled="disabledForm"
          >
            <i class="fa fa-search"></i> ค้นหาข้อมูล
          </Button>
        </div>

        <div class="referral-person-form-container row clearfix">
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">ชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                :class="{ 'bd-red': referrerValidationErrors.has('firstname') }"
                v-model="referrerFirstname"
                :disabled="disabledForm || isReferrerExisting"
              />
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">นามสกุล</span>
              <input
                type="text"
                class="form-control input-sm"
                :class="{ 'bd-red': referrerValidationErrors.has('lastname') }"
                v-model="referrerLastname"
                :disabled="disabledForm || isReferrerExisting"
              />
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">รหัสพนักงาน</span>
              <input
                type="text"
                class="form-control input-sm"
                :class="{ 'bd-red': referrerValidationErrors.has('staffId') }"
                v-mask="'###############'"
                v-model="referrerStaffId"
                :disabled="disabledForm || isReferrerExisting"
              />
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">เลขที่สาขา</span>
              <input
                type="text"
                class="form-control input-sm"
                :class="{ 'bd-red': referrerValidationErrors.has('branchId') }"
                v-mask="'##########'"
                v-model="referrerBranchId"
                :disabled="disabledForm || isReferrerExisting"
              />
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { Validator } from 'vee-validate'
import { mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Button from '@/components/Button'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

const { mapFields: mapReferrerFields } = createHelpers({
  getterType: 'getReferrerFields',
  mutationType: 'updateReferrerFields',
})

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

export default {
  name: 'ReferralForm',
  props: ['typeInsurance', 'quotationId', 'disabledForm'],
  data() {
    return {
      staffSearchId: '',
    }
  },
  watch: {
    referrerType() {
      this.staffSearchId = ''
      this.referrerFirstname = ''
      this.referrerLastname = ''
      this.referrerStaffId = ''
      this.referrerBranchId = ''
    },
    quotationInformation: {
      handler() {
        if (this.quotationInformation) {
          const { referrerInfo } = this.quotationInformation

          const referralStaffId = _.get(referrerInfo, 'referralStaffId', null)
          const firstname = _.get(referrerInfo, 'firstname', null)
          const lastname = _.get(referrerInfo, 'lastname', null)
          const branchId = _.get(referrerInfo, 'branchId', null)

          if (referralStaffId) {
            this.isHasReferrer = true
            this.referrerType = 'existing'

            this.$nextTick(() => {
              this.referrerFirstname = firstname
              this.referrerLastname = lastname
              this.referrerStaffId = referralStaffId
              this.referrerBranchId = branchId
            })
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapReferrerFields({
      isHasReferrer: 'data.isHasReferrer',
      referrerType: 'data.type',
      referrerFirstname: 'data.firstname',
      referrerLastname: 'data.lastname',
      referrerStaffId: 'data.staffId',
      referrerBranchId: 'data.branchId',
      referrerValidationErrors: 'validation.errors',
    }),
    ...mapQuotationFields({
      quotationInformation: 'quotationInformation.data',
    }),
    isReferrerExisting() {
      return this.referrerType === 'existing'
    },
  },
  components: {
    Button,
    Panel,
    Radio,
  },
  methods: {
    ...mapActions(['getReferrerInformation']),
    onCheckHasReferralPerson($evt) {
      this.isHasReferrer = $evt.target.checked
    },
    onSearchStaffInformation() {
      this.getReferrerInformation({ staffId: this.staffSearchId })
    },
  },
}
</script>

<style lang="scss">
.referral-form-container {
  .panel-container {
    &.hide-panel-body {
      .panel-body {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .referral-radio-container {
    display: inline-block;
    margin-right: 32px;
  }

  .referral-search-container {
    margin-bottom: 12px;
  }
}
</style>
